/* eslint-disable @typescript-eslint/ban-ts-comment */
import { SearchClient } from 'algoliasearch';
import { liteClient as algoliasearch, SearchQuery } from 'algoliasearch/lite';
import {
  ALGOLIA_APP_ID,
  ALGOLIA_APP_KEY,
  ALGOLIA_INITIAL_SEARCH,
  ALGOLIA_INDEX_NAME,
} from 'constants/algolia';
import {
  createNullCache,
  createBrowserLocalStorageCache,
  createMemoryCache,
  createFallbackableCache,
} from '@algolia/client-common';
import { cookiesIdHandler } from 'middleware/cookieMiddlewareIdHandler';
import aa from 'search-insights';

if (!ALGOLIA_APP_ID || !ALGOLIA_APP_KEY || !ALGOLIA_INDEX_NAME) {
  throw new Error('Algolia Application ID, API Key and Index must be defined in .env');
}

interface Params {
  query?: string;
  numericFilters?: string[];
  highlightPostTag?: string;
  highlightPreTag?: string;
}

type CustomSearchQuery = SearchQuery & {
  params?: Params;
}

const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_APP_KEY, {
  requestsCache: createMemoryCache({ serializable: false }),
  responsesCache: createFallbackableCache({
    caches: [
      createBrowserLocalStorageCache({
        key: 'algolia-responses',
        timeToLive: 600,
      }),
      createMemoryCache(),
      createNullCache(),
    ],
  }),
});

const searchClient: SearchClient = {
  ...algoliaClient,
  // @ts-ignore
  search(requests: CustomSearchQuery[]) {
  // TODO: check the reason for two requests with the difference between highlightPostTag and highlightPreTag
    requests.forEach((request) => {
      delete request?.params?.highlightPostTag;
      delete request?.params?.highlightPreTag;
    });
    const searchBarRequest = requests.find((request) => request.indexName === ALGOLIA_INDEX_NAME);
    const numberRequests = requests?.length;

    const isInitialSearch = searchBarRequest?.params?.query === ALGOLIA_INITIAL_SEARCH;
    if (isInitialSearch) return Promise.resolve({ results: requests.map(() => ({ hits: [] })) });

    if (searchBarRequest && numberRequests === 1) {
      const date = searchBarRequest?.params?.numericFilters;
      if (searchBarRequest?.params?.query === '' && (!date || date.length === 0)) {
        return Promise.resolve({
          results: requests.map(() => ({ hits: [] })),
        });
      }
    }

    return algoliaClient.search(requests);
  },
};

export default searchClient;

let sessionId = cookiesIdHandler().getSessionId();
if (!sessionId) sessionId = cookiesIdHandler().createSessionId();

const initInsightsAlgolia = () => {
  aa('init', {
    appId: ALGOLIA_APP_ID,
    apiKey: ALGOLIA_APP_KEY,
  });

  aa('setUserToken', sessionId);
};

initInsightsAlgolia();
export const userTokenAlgolia = sessionId;

export const setAuthenticatedUserTokenAlgolia = () => {
  aa('setAuthenticatedUserToken', sessionId);
};
